import React from 'react'
import { TextField, RadioField } from '../fields'
import { YES_NO_OPTIONS } from '../constants'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const DentalHistory = ({ values, setValue, errors }) => (
  <StepCard>
    <TitleContainer>
      <StepIndicator>3</StepIndicator>
      <SectionTitle>Dental History</SectionTitle>
    </TitleContainer>
    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Who is your general dentist?"
          value={values.general_dentist || ''}
          onChange={v => setValue('general_dentist', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="What is your most concern?"
          value={values.most_concern || ''}
          onChange={v => setValue('most_concern', v)}
        />
      </FieldWrapper>
    </Row>
    <Row>
      <FieldWrapper $basis="100%">
        <TextField
          fullWidth
          label="Have you had orthodontic treatment?"
          value={values.orthodontic_treatment || ''}
          onChange={v => setValue('orthodontic_treatment', v)}
        />
      </FieldWrapper>
    </Row>
    <Row>
      <FieldWrapper $basis="100%">
        <RadioField
          label="Do you premedicate before your dental appointments? *"
          options={YES_NO_OPTIONS}
          value={values.premedication || ''}
          error={errors.premedication}
          onChange={v => setValue('premedication', v)}
        />
      </FieldWrapper>
    </Row>
  </StepCard>
)

export default DentalHistory
